import Factory from '../factory';

const schema = Factory.schema('container');

export default schema;
